import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import ThreeDots from "assets/img/icons/three-dots.svg?react";

export interface ThreadCommentActionsProps {
    /** Whether the current user can edit this comment */
    canEdit: boolean;
    /** Callback when edit is clicked */
    onEdit?: () => void;
    /** Callback when delete is clicked */
    onDelete?: () => void;
    /** Additional CSS classes */
    className?: string;
}

/**
 * Unified comment actions menu (edit/delete three-dot menu)
 * Used across all thread contexts
 */
export function ThreadCommentActions({
    canEdit,
    onEdit,
    onDelete,
    className = "",
}: ThreadCommentActionsProps) {
    if (!canEdit) {
        return null;
    }

    return (
        <DropdownMenu.Root>
            <DropdownMenu.Trigger asChild>
                <button
                    className={`cursor-pointer focus:outline-hidden ${className}`}
                    aria-label="Comment actions"
                >
                    <ThreeDots />
                </button>
            </DropdownMenu.Trigger>
            <DropdownMenu.Content
                className="z-50 mt-2 w-40 rounded-md border bg-white shadow-lg"
                align="end"
            >
                {onEdit && (
                    <DropdownMenu.Item
                        onClick={onEdit}
                        className="cursor-pointer rounded-md bg-gray-100 px-4 py-2 text-sm text-[#424242] hover:bg-gray-200 focus:outline-hidden"
                    >
                        Edit
                    </DropdownMenu.Item>
                )}
                {onDelete && (
                    <DropdownMenu.Item
                        onClick={onDelete}
                        className="cursor-pointer rounded-md px-4 py-2 text-sm text-red-600 hover:bg-gray-100 focus:outline-hidden"
                    >
                        Delete
                    </DropdownMenu.Item>
                )}
            </DropdownMenu.Content>
        </DropdownMenu.Root>
    );
}
